export class DecisionValue {
  id: string;
  value: number;
}
